export default __webpack_public_path__ + "static/media/tudo_benefits.fa26730a.svg";